export default "__VITE_ASSET__37149715__"